import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import 'RLX/Style/Base.scss';
import 'Site/Style/var/fonts.scss';

import { visibleIf } from 'Core/Utils';
import ErrorView from 'Core/Status/ErrorView';
import LoadingView from 'Core/Status/LoadingView';

import AuthView from 'Auth';
import Dashboard from 'Dashboard';
import RLXStore from 'RLX/State/Store';
import AppController from 'RLX/Controllers/AppController';

import { dismissError } from 'RLX/State/Ui/UiActions';
import { loadSite } from 'RLX/State/Content/ContentActions';
import { refreshAuthStatus, attemptLogout } from 'RLX/State/Auth/AuthActions';

class RLX extends AppController {
  constructor (props) {
    super(props);
    this.renderLogout = this.renderLogout.bind(this);
    refreshAuthStatus();
  }

  renderLogout () {
    const { match } = this.props;
    return confirm('Are you sure you want to log out?') && attemptLogout()
      ? <Redirect to={match.url + '/login'} />
      : <Redirect to={match.url + '/dash'} />
  }

  render () {
    const { location, match } = this.props;
    const { ui, auth } = this.state;
    const { broken, loading, errorMessage } = ui;

    const Logout = this.renderLogout;
    const at = (path = '') => match.url + path;

    return (
      <div className="RLX Root">
        <ErrorView
          style={visibleIf(broken)}
          message={errorMessage}
          onDismiss={dismissError}
        />
        <LoadingView style={visibleIf(loading)} />
        <Route path={at()} style={visibleIf(!loading && !broken)}>
          {auth.loggedIn
            ? (
              <Switch>
                <Route path={at('/logout')} render={Logout} />
                <Route component={Dashboard} />
              </Switch>
              ) : (
              <Switch>
                <Route exact path={at('/login')} component={AuthView} />
                <Route exact path={at('/register')} component={AuthView} />
                <Redirect to={{ pathname: at('/login') }} />
              </Switch>
            )
          }
        </Route>
      </div>
    );
  }
};

export default RLX;



// WEBPACK FOOTER //
// ./client/RLX/RLX.jsx